import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "../config";

function VerifyLicence() {
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [checkingStatus, setCheckingStatus] = useState(true);

  useEffect(() => {
    const checkStatus = async () => {
      try {
        const token = localStorage.getItem("token");

        const res = await fetch(`${API_BASE_URL}/api/verifyLicence/status`, {
          method: "GET",
          headers: {
            Authorization: token ? `Bearer ${token}` : "",
          },
        });

        const data = await res.json();

if (data.verified) {
  const meRes = await fetch(`${API_BASE_URL}/api/auth/me`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });

  const freshUser = await meRes.json();
  localStorage.setItem("user", JSON.stringify(freshUser));

  setIsVerified(true);
  setMessage(
    "🎉 Identity successfully verified. Redirecting you to your dashboard..."
  );

  setTimeout(() => {
    window.location.href = "/dashboard";
  }, 2500);
}
        
      } catch (err) {
        console.error("❌ Verification status check error:", err);
      } finally {
        setCheckingStatus(false);
      }
    };

    checkStatus();
  }, []);

  const startVerification = async () => {
    if (isSubmitting) return;

    setIsSubmitting(true);
    setMessage("");

    try {
      const token = localStorage.getItem("token");

      const res = await fetch(`${API_BASE_URL}/api/verifyLicence`, {
        method: "POST",
        headers: {
          Authorization: token ? `Bearer ${token}` : "",
        },
      });

      const data = await res.json();

      if (res.ok && data.success && data.redirectUrl) {
        window.location.href = data.redirectUrl;
        return;
      }

      if (data.alreadyVerified) {
        setIsVerified(true);
        setMessage("✅ Identity already verified.");
        return;
      }

      setMessage(data.error || "Could not start identity verification.");
    } catch (err) {
      console.error("❌ Stripe Identity frontend error:", err);
      setMessage("❌ Could not start identity verification. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };
const goToDashboard = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await fetch(`${API_BASE_URL}/api/auth/me`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const freshUser = await res.json();

      localStorage.setItem("user", JSON.stringify(freshUser));

      window.location.href = "/dashboard";
    } catch (err) {
      console.error("Failed to refresh user:", err);
    }
  };
  return (
    <div style={containerStyle}>
      <h2 style={headerStyle}>Identity Verification</h2>

      {checkingStatus && (
        <div style={messageStyle}>Checking verification status...</div>
      )}

      {message && (
        <div style={isVerified ? successBox : messageStyle}>
          {message}
        </div>
      )}

      <p style={paragraphStyle}>
        To protect businesses and keep Client Exchange trusted, we use Stripe
        Identity to verify users securely.
      </p>

      <p style={paragraphStyle}>
        Client Exchange does not collect or store your licence document. Stripe
        handles the identity check securely.
      </p>

      {!isVerified && !checkingStatus && (
        <button
          type="button"
          onClick={startVerification}
          style={buttonStyle}
          disabled={isSubmitting}
        >
          {isSubmitting
            ? "Starting verification..."
            : "Verify identity with Stripe"}
        </button>
      )}

      {isVerified && (
        <button
          type="button"
          onClick={goToDashboard}
          style={buttonStyle}
        >
          Go to Dashboard
        </button>
      )}

      <div style={infoBox}>
        <h3 style={{ color: "#2e7d32", marginBottom: "10px" }}>
          🔐 Your Privacy
        </h3>
        <p style={{ fontSize: "13px", color: "#555" }}>
          Stripe may ask for a government ID and selfie to confirm your
          identity. Client Exchange only stores the verification result.
        </p>
      </div>
    </div>
  );
}

const containerStyle = {
  maxWidth: "500px",
  margin: "50px auto",
  padding: "30px",
  borderRadius: "12px",
  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  backgroundColor: "#fff",
};

const headerStyle = {
  textAlign: "center",
  marginBottom: "20px",
  fontSize: "26px",
  color: "#2e7d32",
};

const paragraphStyle = {
  fontSize: "14px",
  color: "#333",
  lineHeight: "1.5",
  textAlign: "center",
};

const buttonStyle = {
  width: "100%",
  padding: "15px",
  marginTop: "20px",
  backgroundColor: "#2e7d32",
  color: "white",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  fontWeight: "bold",
  fontSize: "16px",
};

const messageStyle = {
  padding: "12px",
  borderRadius: "8px",
  textAlign: "center",
  marginBottom: "15px",
  fontWeight: "500",
  backgroundColor: "#e8f5e9",
  color: "#2e7d32",
};

const successBox = {
  padding: "15px",
  borderRadius: "8px",
  backgroundColor: "#e8f5e9",
  color: "#2e7d32",
  textAlign: "center",
  marginBottom: "20px",
  fontWeight: "bold",
};

const infoBox = {
  border: "2px dashed #2e7d32",
  borderRadius: "12px",
  padding: "20px",
  textAlign: "center",
  marginTop: "25px",
  backgroundColor: "#f9fff9",
};

export default VerifyLicence;